module.exports = __webpack_public_path__ + "img/empty.b48c50ef.png";